/**
 * Testi italiani della pagina «Scadenze» dell'amministrazione (ADR 0044).
 *
 * «Token» e «chiave API» restano: sono i nomi che l'amministratore legge sui siti dei
 * fornitori.
 */

/** Testi delle scadenze. */
export const deadlines = {
  /** Voce di menu e scheda. */
  tab: 'Scadenze',
  /** Titolo della pagina. */
  title: 'Scadenze',
  /** Descrizione sotto il titolo. */
  description:
    'Token, chiavi API, prove e abbonamenti della piattaforma. Le connessioni GitHub e Google di institor compaiono da sole.',
  /** Caricamento non riuscito. */
  loadFailed: 'Caricamento delle scadenze non riuscito. Riprova.',
  /** Riepilogo in alto. */
  summary: {
    /** Già scadute. */
    expired: 'Scadute',
    /** Entro il preavviso. */
    soon: 'In scadenza',
    /** Le altre. */
    ok: 'In regola',
  },
  /** Urgenze. */
  urgency: {
    expired: 'Scaduta',
    soon: 'In scadenza',
    ok: 'In regola',
  },
  /** Giorni mancanti. */
  daysLeft_one: 'manca {{count}} giorno',
  daysLeft_other: 'mancano {{count}} giorni',
  /** Scade oggi. */
  today: 'scade oggi',
  /** Giorni passati. */
  daysAgo_one: 'scaduta da {{count}} giorno',
  daysAgo_other: 'scaduta da {{count}} giorni',
  /** Tipi. */
  kinds: {
    token: 'Token',
    api_key: 'Chiave API',
    certificate: 'Certificato',
    subscription: 'Abbonamento',
    trial: 'Prova',
    domain: 'Dominio',
    other: 'Altro',
  },
  /** Elenco delle voci scritte a mano. */
  manual: {
    /** Titolo della scheda. */
    title: 'Scadenze registrate',
    /** Pulsante della voce nuova. */
    add: 'Aggiungi scadenza',
    /** Stato vuoto. */
    empty: 'Nessuna scadenza registrata.',
    /** Colonne. */
    columns: {
      title: 'Nome',
      kind: 'Tipo',
      provider: 'Fornitore',
      expiresAt: 'Scadenza',
      state: 'Stato',
      actions: 'Comandi',
    },
    /** Collegamento alla pagina di rinnovo. */
    open: 'Apri pagina di rinnovo',
    /** Nome accessibile del collegamento. */
    openAccessible: 'Apri la pagina di rinnovo di {{title}}',
    /** Pulsanti della riga. */
    edit: 'Modifica',
    editAccessible: 'Modifica {{title}}',
    remove: 'Elimina',
    removeAccessible: 'Elimina {{title}}',
    /** Conferma della cancellazione. */
    removeConfirmTitle: 'Eliminare la scadenza?',
    removeConfirmText: '«{{title}}» sparisce dall’elenco. Il token o l’abbonamento non cambia.',
    cancel: 'Annulla',
    /** Esiti. */
    removed: 'Scadenza eliminata.',
    removeFailed: 'Eliminazione non riuscita. Riprova.',
  },
  /** Modulo della voce. */
  form: {
    /** Titolo della finestra di una voce nuova. */
    newTitle: 'Nuova scadenza',
    /** Titolo della finestra di modifica. */
    editTitle: 'Modifica scadenza',
    title: 'Nome',
    titleHelp: 'Per esempio «Prova GitHub Enterprise» o «Token API di Cloudflare».',
    titleRequired: 'Scrivi il nome della scadenza.',
    kind: 'Tipo',
    provider: 'Fornitore',
    expiresAt: 'Data di scadenza',
    expiresAtRequired: 'Scegli la data di scadenza.',
    warnDays: 'Preavviso in giorni',
    warnDaysHelp: 'Da quanti giorni prima la scadenza compare come «In scadenza».',
    url: 'Pagina di rinnovo',
    urlHelp: 'Indirizzo che inizia con https://. Facoltativo.',
    urlInvalid: 'L’indirizzo deve iniziare con https://.',
    notes: 'Note',
    notesHelp: 'Non scrivere qui token, password o chiavi.',
    save: 'Salva',
    cancel: 'Annulla',
    /** Esiti. */
    created: 'Scadenza aggiunta.',
    updated: 'Scadenza aggiornata.',
    saveFailed: 'Salvataggio non riuscito. Riprova.',
  },
  /** Connessioni di piattaforma. */
  connections: {
    title: 'Connessioni di institor',
    intro: 'Token di GitHub e Google collegati nella pagina Piattaforma. Per rinnovarli usa «Modifica» in quella pagina.',
    empty: 'Nessuna connessione di institor con una scadenza.',
    columns: {
      name: 'Nome',
      provider: 'Fornitore',
      account: 'Account',
      expiresAt: 'Scadenza',
      state: 'Stato',
    },
    noExpiry: 'Senza scadenza',
    invalid: 'Non valida',
    expiredStatus: 'Scaduta',
    goToPlatform: 'Vai a Piattaforma',
  },
  /** Connessioni di utenti e progetti. */
  owned: {
    title: 'Connessioni di utenti e progetti',
    text: '{{expired}} scadute o non valide, {{expiring}} in scadenza nei prossimi {{days}} giorni. Le rinnovano i loro proprietari.',
  },
};

/** Forma dei testi delle scadenze. */
export type Deadlines = typeof deadlines;
